import {FormControl, FormField} from 'platform/components';
import {Box, Integer} from 'platform/foundation';

import {FieldPathByValue, useWatch} from 'react-hook-form';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface PageItemNumberInputProps {
  isReadOnly?: boolean;
  index: number;
  isCollapsed: boolean;
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  name: FieldPathByValue<DeliveryNoteDocumentPreviewFormDefinition, number | Nullish>;
  width: Integer;
  onChange: (fieldName: string, value: string | number) => void;
}

export function PageItemNumberInput(props: PageItemNumberInputProps) {
  const [value, isActive] = useWatch({
    control: props.control,
    name: [props.name, `listOfItems.${props.index}.isActive`],
  });

  const handleChange = (value: number | null) => {
    if (isNil(value)) {
      return;
    }
    props.onChange(props.name, value);
  };

  return (
    <Box paddingHorizontal={2} width={props.isCollapsed ? '100%' : props.width}>
      <FormField
        isAutoselectedOnFocus
        isDisabled={props.isReadOnly || !props.isConfirmed || !isActive}
        isInvalid={props.isConfirmed && isActive && (!value || value <= 0)}
        control={props.control}
        type="number"
        name={props.name}
        decimalPlaces={4}
        onChange={handleChange}
      />
    </Box>
  );
}
